





















































import { Component, Prop, Watch } from "vue-property-decorator";
import { SimpleLookupModel, CompanyFollowupStatusModel, TransferCompanyModel } from "@/core/models";
import { CompanyService } from "@/core/services";
import { InputSelectCpt, InputDateCpt } from "@/core/components";

import AppVue from "@/AppVue.vue";

@Component({
  components: { InputSelectCpt, InputDateCpt },
})
export default class TransferCompanyWorkshopDialogCpt extends AppVue {
  @Prop({ default: false }) showDialog: boolean;
  @Prop() companyId: number;
  @Prop() companyName: string;

  model = new TransferCompanyModel();
  loading = false;
  counties = [] as SimpleLookupModel[];

  get isOpen() {
    return this.showDialog;
  }

  get title() {
    return `Transfer client - ${this.companyName}`;
  }

  get isValidForm() {
    return !!this.model.countyId && !!this.model.eventDate;
  }

  async created() {
    this.initializeCounties();
  }

  private async initializeCounties() {
    this.loading = true;
    try {
      this.counties = await CompanyService.getCounties();
    } finally {
      this.loading = false;
    }
  }

  private close(workshopId: number = null as any) {
    this.model.countyId = null as any;
    this.model.eventDate = new Date();
    this.$emit("close", workshopId);
  }

  private async save() {
    this.loading = true;
    try {
      this.model.companyId = this.companyId;
      const workshop = await CompanyService.transferClient(this.model);
      if (workshop) {
        this.close(workshop.id);
      } else {
        this.notify("Workshop not found", "Workshop not found for the selected date and location.", "warning");
      }
    } catch {
      this.notify("Error", "Something went wrong on trasfering client.", "error");
    } finally {
      this.loading = false;
    }
  }
}
